import labelTranslator from './labelTranslator';

/**
 * Translates server error details into human consumable messages.
 *
 * @param {String} path Name of the locale path that labels are associated with
 * @param {Object} errs Object of error details to append labels to
 * @returns {Object} An object of errors to be presented to the user
 */
export default (path, errs, opts = {}) => {
  const errors = {};

  if (errs) {
    for (const key in errs) {
      if (errs.hasOwnProperty(key)) {
        let attribute = key;

        if (opts.nestedPath) {
          const keys = key.split('.');

          if (keys.length > 1 && keys[0] === path) {
            attribute = keys[1];
          }
        }

        if (attribute) {
          errors[attribute] = `${labelTranslator(path, attribute)} ${errs[key][0]}`;
        }
      }
    }
  }

  if (Object.keys(errors).length > 0) {
    return errors;
  }

  return null;
};



// WEBPACK FOOTER //
// ./app/lib/handleServerValidation.js